import { ViewType } from "../../../../components/fileView/FileType";
import { urls } from "../../../../config/url";
import httpRequest from "../../../../utils/HttpRequest";

export async function fetchImmage(filePath: string): Promise<string> {
    return httpRequest(urls.getImageBlob, {
        FILEPATH: filePath
    }, { responseType: 'blob' }).then(response => {
        return URL.createObjectURL(response.data)
    })
}

export async function fetchText(filePath: string): Promise<string> {
    return httpRequest(urls.getTextFileContent, {
        FILEPATH: filePath
    }).then(response => {
        if (response.data.errno === 0) {
            return response.data.data;
        }
        else
            throw new Error(response.data.errmsg);
    })
}

export async function fetchFile(filePath: string, type: ViewType): Promise<string> {
    switch (type) {
        case ViewType.IMAGE:
            return fetchImmage(filePath);
        case ViewType.TEXT:
            return fetchText(filePath);
        case ViewType.CSV:
            return fetchText(filePath);
        default:
            throw new Error("Type error!");
    }
}